export default __webpack_public_path__ + "static/media/black_white_logo.08aead10.jpg";